"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var orderBy_1 = tslib_1.__importDefault(require("lodash/orderBy"));
var ProjectsPage = /** @class */ (function (_super) {
    tslib_1.__extends(ProjectsPage, _super);
    function ProjectsPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProjectsPage.prototype.render = function () {
        var projectItems = this.props.store.data.projectItems;
        return (react_1.default.createElement("div", { className: "projects limiter" },
            react_1.default.createElement("div", { className: "section section_grey section_no-padding" },
                react_1.default.createElement("div", { className: "projects__list" }, orderBy_1.default(projectItems, 'order', 'asc').map(function (project) {
                    return (react_1.default.createElement("a", { key: project.id, className: "projects__item", href: "/projects/" + project.slug },
                        react_1.default.createElement("div", { className: "projects__item-image", style: {
                                backgroundImage: "url(" + project.images[0].url + ")",
                            } }),
                        react_1.default.createElement("div", { className: "projects__item-title" }, project.title)));
                })))));
    };
    ProjectsPage = tslib_1.__decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], ProjectsPage);
    return ProjectsPage;
}(react_1.default.Component));
exports.ProjectsPage = ProjectsPage;
